import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react'
import { useCallback } from 'react'

import { cn } from '@/lib/utils'

import { type SortOrder } from './types'

export const SortButton = (props: {
  /**
   * Current sort order of the corresponding column, if any.
   */
  sortOrder?: SortOrder
  disabled?: boolean
  title: string
  onSortOrderChange: (sortOrder?: SortOrder) => void
}) => {
  const handleClick = useCallback(() => {
    const sortOrder_ = rotateSortOrder(props.sortOrder)

    props.onSortOrderChange(sortOrder_)
  }, [props])

  return (
    <button
      className={cn('flex items-center gap-1', props.disabled && 'cursor-default')}
      disabled={props.disabled}
      onClick={handleClick}
    >
      {props.title}
      <SortOrderIcon className={cn(props.disabled && 'opacity-50')} sortOrder={props.sortOrder} />
    </button>
  )
}

const SortOrderIcon = (props: { sortOrder?: SortOrder; className?: string }) => {
  switch (props.sortOrder) {
    case 'asc':
      return <ArrowUp size={13} className={props.className} />
    case 'desc':
      return <ArrowDown size={13} className={props.className} />
    default:
      return <ChevronsUpDown size={13} className={props.className} />
  }
}

/**
 * Given a current sort order, returns the next sort order for a column.
 *
 * - The order rotation is: `"asc"` -> `"desc"` -> `undefined`.
 * - `undefined` represents that the column is not sorted.
 */
const rotateSortOrder = (sortOrder?: SortOrder) => {
  switch (sortOrder) {
    case 'asc':
      return 'desc'
    case 'desc':
      return undefined
    default:
      return 'asc'
  }
}
